import React, { useEffect, useState, useRef, useMemo } from "react";
import Loader from "../component/Loader";
import Modal from "react-modal";
import { FaRegTimesCircle } from "react-icons/fa";
import Select from "react-select";
import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css'; // Import CSS for Typeahead
import { useDebounce } from 'use-debounce';
import { getData, postData } from "../store/utils";
import { MdDelete } from "react-icons/md";
import Swal from "sweetalert2";
import { Link, useHistory } from "react-router-dom/cjs/react-router-dom";
import { FaUpload } from "react-icons/fa";

const customStyles = {
    content: {
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)",
        overflow: "none",
        padding: "0px",
        minWidth: "50%",
        maxWidth: "50%",
    },
};

function New() {
    const [isLoadingOn, setIsLoadingOn] = useState(false);
    const [modalIsOpen, setIsOpen] = useState(false);
    const today = new Date().toISOString().split("T")[0]; // Get today's date
    const [itemListData, setItemListData] = useState([])
    const [searchText, setSearchText] = useState('');
    const [searchValue] = useDebounce(searchText, 1000);
    const [brandId, setBrandId] = useState('')
    const [totalRoiRows, setTotalRoiRows] = useState([{ id: 1 }]);
    const [errors, setErrors] = useState({});
    const [showTopMessage, setShowTopMessage] = useState(false);
    const [vendorList, setVendorList] = useState([]);
    const [wareHouseList, setWareHouseList] = useState([]);
    const [isWarehouseSelected, setIsWarehouseSelected] = useState(false);
    const [poNumber, setPOnumber] = useState(null)
    const history = useHistory();
    const [paymentTermsList, setPaymentTermsList] = useState([
        { value: 1, label: "Net 30" },
        { value: 2, label: "Net 60" },
        { value: 3, label: "Net 90" },
        { value: 4, label: "Due on Receipt" },
        { value: 5, label: "Due end of the month" },
        { value: 6, label: "Due end of next month" },
    ]);

    const [account, setAccount] = useState([
        { value: 1, label: "Inventory" },
        { value: 2, label: "Advance Tax" },
        { value: 3, label: "Employee Advance" },
        { value: 4, label: "Prepaid Expenses" },
        { value: 5, label: "TDS Receivable" },
        { value: 6, label: "Furniture and Equipment" },
    ]);

    const [formData, setFormData] = useState({
        visibleLable: false,
        vendorId: "",
        vendorName: "",
        deliveryAddress: "",
        purchaseOrder: poNumber,
        orderTotal: "",
        orderTotalWithDiscount: "",
        reference: "",
        date: today,
        deliveryDate: "",
        paymentTermsId: "",
        paymentTerms: "",
        customerNotes: "",
        termsAndConditions: "",
        discount: "",
        gst: "18",
        tdsOrTcs: "",
        adjustment: "Adjustment",
        adjustmentInRupees: "",
        orderDetails: [
            {
                productId: "",
                distributorId: "",
                distributorProductId: "",
                account: "",
                quantity: "",
                rate: "",
                amount: ""
            }
        ],
        file: [
            {
                fileType: "",
                file: ""
            }
        ],
    });


    // Calculate Subtotal
    const subTotal = formData?.orderDetails.reduce(
        (total, row) => total + (parseFloat(row?.totalAmount) || 0),
        0
    );

    const gstAmount = (subTotal * parseFloat(formData.gst || 0)) / 100;

    // Calculate total after GST (GST added to the original SubTotal)
    const totalAfterGST = subTotal + gstAmount;

    // Apply discount after GST is added
    const discountAmount = (totalAfterGST * parseFloat(formData.discount || 0)) / 100;

    // Calculate total after discount
    const totalAfterDiscount = totalAfterGST - discountAmount;

    // Calculate the final total with adjustments
    const finalTotal = totalAfterDiscount + parseFloat(formData.adjustmentInRupees || 0);



    // Update formData when any of the values change
    useEffect(() => {
        setFormData((prev) => ({
            ...prev,
            orderTotal: subTotal.toFixed(2),
            orderTotalWithDiscount: finalTotal.toFixed(2),
        }));
    }, [subTotal, discountAmount, gstAmount, finalTotal]);


    // Handle Discount Change
    const handleDiscountChange = (event) => {
        setFormData((prev) => ({
            ...prev,
            discount: event.target.value,
        }));
    };

    const handleGstChange = (event) => {
        setFormData((prev) => ({
            ...prev,
            gst: event.target.value,
        }));
    };

    // Handle Adjustment Change
    const handleAdjustmentChange = (event) => {
        setFormData((prev) => ({
            ...prev,
            adjustmentInRupees: event.target.value,
        }));
    };


    async function getVendors() {
        setIsLoadingOn(true);
        const tempData = await getData("users/distributorUser/1");
        setIsLoadingOn(false);
        if (tempData.statusCode === 200 && tempData.data.records) {
            const tempDistData = tempData.data.records.map(element => ({
                value: element.id,
                label: `${element.shopName} (${element.name})`,
            }));
            setVendorList(tempDistData);
        } else {
            console.error("Error fetching User brands.");
            Swal.fire({
                title: "Error!",
                text: tempData?.data?.errors.msg || "Something went wrong!!!"
            })
        }
    }

    async function getPO() {
        setIsLoadingOn(true);
        const tempData = await getData("/inventory/getPurchaseOrderIds");
        
        setIsLoadingOn(false);
        if (tempData.statusCode === 200 && tempData.data) {
            setPOnumber(tempData?.data?.nextPurchaseOrderId)

        } else {
            console.error("Error fetching User brands.");
            // Swal.fire({
            //     title: "Error!",
            //     text: tempData?.data?.errors.msg || "Something went wrong!!!"
            // })
        }
    }

    console.log(poNumber)


    async function getWarehouse() {
        setIsLoadingOn(true);
        const tempData = await getData("/warehouse/getWarehouse");
        console.log("tempData", tempData);
        setIsLoadingOn(false);
        if (tempData.statusCode === 200 && tempData.data.data) {
            const tempDistData = tempData.data.data.map(element => ({
                value: element.warehouseId,
                label: element.warehouseName,
                address: element.address, // 👈 include delivery address here
                warehouseId: element.warehouseId, // 👈 for future reference
            }));
            setWareHouseList(tempDistData);
        } else {
            console.error("Error fetching User brands.");
            Swal.fire({
                title: "Error!",
                text: tempData?.data?.errors.msg || "Something went wrong!!!"
            })
        }
    }

    const handleWarehouseChange = (selectedOption) => {
        console.log("selectedOption", selectedOption);
        if (selectedOption) {
            setFormData((prevFormData) => ({
                ...prevFormData,
                deliveryAddress: selectedOption.address,
                warehouseId: selectedOption.warehouseId,
            }));
            setIsWarehouseSelected(true);
        }
    }

    useEffect(() => {
        getVendors();
        getWarehouse();
        getPO();
    }, [])

    useEffect(() => {
        if (poNumber) {
            setFormData((prev) => ({
                ...prev,
                purchaseOrder: poNumber
            }));
        }
    }, [poNumber]);

    const validateForm = () => {
        let newErrors = {};
        if (!formData.vendorName) {
            newErrors.vendorName = "Vendor Name is required.";
        }
        if (!formData.deliveryAddress) {
            newErrors.deliveryAddress = "Delivery Address is required.";
        }
        if (!formData.purchaseOrder) {
            newErrors.purchaseOrder = "Purchase Order is required.";
        }


        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };


    const handleAddVendorNameChange = (selectedOption) => {
        console.log("selectedOption", selectedOption);
        if (selectedOption) {
            setFormData((prevFormData) => ({
                ...prevFormData,
                vendorName: selectedOption.label,
                vendorId: selectedOption.value,
            }));
        }
    };

    const handleAddPaymentTermsChange = (selectedOption) => {

        if (selectedOption) {
            setFormData((prevFormData) => ({
                ...prevFormData,
                paymentTerms: selectedOption.label,
                paymentTermsId: selectedOption.value,
            }));
        }
    }

    const handleAccountChange = (selectedOption, index) => {
        const updatedOrderDetails = [...formData.orderDetails];
        updatedOrderDetails[index].account = selectedOption?.label || "";

        setFormData((prevFormData) => ({
            ...prevFormData,
            orderDetails: updatedOrderDetails,
        }));
    };


    const handleChange = (e) => {
        const { name, value } = e.target;
        console.log(name, value);
        setFormData((prevFormData) => ({
            ...prevFormData,
            [name]: value,
        }));
    }

    const handleFileChange = async (e) => {
        const files = Array.from(e.target.files);
        const maxFiles = 3;
        const maxSize = 5 * 1024 * 1024; // 5MB

        let newErrors = {};

        if (files.length > maxFiles) {
            newErrors.images = `Maximum ${maxFiles} images allowed.`;
        }

        const invalidSize = files.find((file) => file.size > maxSize);
        if (invalidSize) {
            newErrors.images = "Each image must be less than 5 MB.";
        }

        if (Object.keys(newErrors).length > 0) {
            setErrors((prev) => ({ ...prev, ...newErrors }));
            setFormData((prev) => ({ ...prev, images: [] }));
        } else {
            // Convert each file to base64
            const base64Files = await Promise.all(
                files.map((file) => convertToBase64(file))
            );

            // Save in formData (you can store fileType as well if needed)
            const fileData = base64Files.map((base64, idx) => ({
                fileType: "image",
                file: base64,
            }));

            setFormData((prev) => ({ ...prev, file: fileData }));
            setErrors((prev) => ({ ...prev, images: null }));
        }
    };


    const convertToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                const base64String = reader.result.split(',')[1]; // 👈 remove data:image/... part
                resolve(base64String);
            };
            reader.onerror = (error) => reject(error);
        });
    };


    const addnewAddress = () => {
        setIsOpen(true);
    };


    const closeModal = () => {
        setIsOpen(false);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoadingOn(true);
        // Perform form submission logic here
        console.log("Form submitted:", formData);

        if (validateForm()) {
            setIsLoadingOn(true);
            // return false
            const res = await postData(`inventory/createPurchaseOrder`, formData);
            setIsLoadingOn(false);
            if (res.statusCode == 200) {
                // history.push('/ProgramList');
                setShowTopMessage(true);
                setTimeout(() => {
                    setShowTopMessage(false);
                }, 3000);
                Swal.fire({
                    icon: "success",
                    title: "Success!",
                    text: "Data inserted successfully!",
                });
                setTimeout(() => {
                    history.push('/purchaseorder');
                }, 3000);

            }
        }
        setIsLoadingOn(false);
    }
    const handleCancel = () => {
        // Perform cancel logic here
        console.log("Form cancelled");
    };
    const handleAddNewRow = () => {
        // Perform add new row logic here
        console.log("Add new row clicked");
    };

    const handleSearchChange = async (selected) => {
        setSearchText(selected)
    };


    async function getProductList(typeValue) {
        // const brandId = 1; // Replace with the actual brand ID you want to use
        setIsLoadingOn(true);
        try {
            const tempData = await getData(`inventory/searchForItemProduct?pageSize=100&page=1&brandId=${brandId}&search=${typeValue}`);

            if (tempData?.statusCode === 200 && tempData?.data && tempData?.data?.records) {
                
                const tempDistData = tempData?.data?.records?.map((element) => {
                    return element
                })
                setItemListData(tempDistData);
            } else {
                console.error("Unexpected response format:", tempData);
                setItemListData([]); // Set to an empty array if response is not as expected
            }
        } catch (error) {
            console.error("Error fetching item list:", error);
            setItemListData([]); // Handle error case
        } finally {
            setIsLoadingOn(false); // Ensure loading is turned off
        }
    }


    useEffect(() => {
        if (searchValue) {
            getProductList(searchValue);
        }
    }, [searchValue]);

    const handleSelectedId = (id, index, distributorProductId) => {
        // Validate itemListData
        if (!Array.isArray(itemListData)) {
            console.error("itemListData is not defined or is not an array");
            return;
        }
        // Find the matching data
        const filterData = itemListData.filter((item) => item?.id === distributorProductId);


        if (filterData?.length === 0) {
            console.log("No matching data found");
        } else {
            // Assuming filterData contains the selected item, and you want to set it in formData
            const selectedItem = filterData[0];
            setFormData((prevState) => {
                if (prevState?.orderDetails) {
                    return {
                        ...prevState,
                        orderDetails: prevState?.orderDetails?.map((item, idx) => {
                            if (idx === index) {
                                return {
                                    ...item,
                                    visibleLable: true,
                                    brandName: selectedItem?.brand,
                                    item: selectedItem?.productName,// getting error "10"
                                    productName: selectedItem?.productName,
                                    categoryName: selectedItem?.productCategory,
                                    quantity: parseInt(selectedItem?.quantity),
                                    rate: parseInt(selectedItem?.rate),
                                    color: selectedItem?.color,
                                    colorId: selectedItem?.colorId,
                                    size: selectedItem?.size,
                                    sizeId: selectedItem?.sizeId,
                                    sGST: "9",
                                    cGST: "9",
                                    totalAmount: selectedItem?.totalAmount,
                                    amount: selectedItem?.totalAmount,
                                    productId: parseInt(selectedItem?.id), //getting errro 852
                                    distributorId: parseInt(selectedItem?.distributorId), //getting errro 852
                                    distributorProductId: parseInt(selectedItem?.id), //getting errro 852
                                    brandId: parseInt(selectedItem?.brandId), //getting errro 18
                                    productCategoryId: parseInt(selectedItem?.productCategoryId), //getting errro 2
                                    buyingPricePerItem: null,
                                    totalBuyingAmount: parseInt(selectedItem?.totalBuyingAmount),
                                    totalSellingAmount: null,
                                    margin: parseInt(selectedItem?.margin),
                                    listingPrice: selectedItem?.listingPrice,
                                    promotionalDiscount: null,
                                    discountToMerchant: selectedItem?.discountToMerchant,
                                    discountToDaqi: selectedItem?.discountToDaqi,
                                    isGstApplicable: selectedItem?.isGstApplicable,
                                    subCategory: selectedItem?.subCategory,
                                    mrpWithCashDiscount: selectedItem?.mrpWithCashDiscount,
                                    shopName: selectedItem?.shopName

                                };
                            }

                            return item; // Return unchanged items
                        }),
                    };
                }
                return prevState; // If no orderQuotation, return unchanged state
            });
        }
    };

    const handleUpdateRowChange = (event, index, field) => {
        const { name, value } = event?.target;
        setFormData((prevState) => {
            const updatedOrderQuotation = [...prevState?.orderDetails];
            console.log("updatedOrderQuotation11221", updatedOrderQuotation);
            updatedOrderQuotation[index] = {
                ...updatedOrderQuotation[index],
                [name]: value,
            };

            if (name === "brandId") {
                setBrandId(value);
            }

            let {
                quantity,
                rate,
                sGST,
                cGST,
                buyingPricePerItem,
                listingPrice,
                isGstApplicable,
                promotionalDiscount,
            } = updatedOrderQuotation[index];
            let tempPromotionalDiscount = promotionalDiscount
                ? promotionalDiscount
                : 0;
            let tmpRate;
            let tempBuyingItem;
            let tempTotalAmount;
            let tempMargin;
            let totalbuying;
            if (Array.isArray(updatedOrderQuotation) && updatedOrderQuotation?.length > 0) {
                let data = updatedOrderQuotation[index];

                if (data) {
                    let tempdiscountToMerchant =
                        Number(data.discountToMerchant || 0) +
                        Number(tempPromotionalDiscount || 0);
                    tmpRate =
                        data.listingPrice - data.listingPrice * (tempdiscountToMerchant / 100);

                    tempBuyingItem =
                        data.listingPrice -
                        (data.listingPrice * (Number(data?.discountToDaqi) || 0)) / 100;
                    quantity = Number(quantity)
                    if (isGstApplicable) {
                        tempTotalAmount = (quantity * tmpRate) + ((quantity * tmpRate) * 0.18); //apply 18% GST on totalAmount if GST is applicable on specfic product
                        totalbuying = (tempBuyingItem * quantity) + ((quantity * tmpRate) * 0.18)
                    } else {
                        tempTotalAmount = quantity * tmpRate;
                        totalbuying = tempBuyingItem * quantity;
                    }

                    tempMargin = tempTotalAmount - totalbuying;

                    updatedOrderQuotation[index] = {
                        ...updatedOrderQuotation[index],
                        totalBuyingAmount: totalbuying.toFixed(2),
                        margin: tempMargin.toFixed(2),
                        discountToMerchant: data?.discountToMerchant,
                        discountToDaqi: data?.discountToDaqi,
                    };
                } else {
                    console.error(`Data at index ${index} is undefined.`);
                }
            } else {
                console.error("programData is not a valid array or is empty.");
            }

            return {
                ...prevState,
                orderDetails: updatedOrderQuotation,
            };
        });
    };

    const handleRateChange = (event, index) => {
        const { name, value } = event.target;

        setFormData((prevState) => {
            const updatedOrderDetails = [...prevState.orderDetails];
            updatedOrderDetails[index] = {
                ...updatedOrderDetails[index],
                [name]: value,
                totalAmount: updatedOrderDetails[index].quantity * value || "", // optional: auto-calculate amount
                amount: updatedOrderDetails[index].quantity * value || "", // optional: auto-calculate amount
            };
            return {
                ...prevState,
                orderDetails: updatedOrderDetails,
            };
        });
    };

    const totalRoiDeleteRow = (id, index) => {
        const updatedRows = totalRoiRows.filter((row) => row?.id !== id);
        setTotalRoiRows(updatedRows);

        setFormData((prevState) => ({
            ...prevState,
            orderDetails: prevState.orderDetails.filter(
                (row, innerIndex) => innerIndex !== index
            ),
        }));
    };

    const totalRoiAddRow = () => {
        const newRow = { id: totalRoiRows?.length + 1 };
        setTotalRoiRows([...totalRoiRows, newRow]);
        setFormData((prevState) => ({
            ...prevState,
            orderDetails: [
                ...prevState.orderDetails,
                {
                    brandName: null,
                    visibleLable: false,
                    productCategory: null,
                    item: null,
                    categoryName: null,
                    quantity: null,
                    rate: null,
                    sGST: "9",
                    cGST: "9",
                    totalAmount: null,
                    distributorId: null,
                    brandId: null,
                    productCategoryId: null,
                    totalBuyingAmount: null,
                    margin: null,
                    listingPrice: null,
                    promotionalDiscount: null,
                    discountToMerchant: null,
                    discountToDaqi: null,
                    isGstApplicable: 0,
                },
            ],
        }));
        // handleShowData("showInputData");
    };


    return (
        <div className="purchaseOrderSec">
            {isLoadingOn ? <Loader /> : ""}
            {/* <h4 style={{ marginBottom: 10 }}>Purchanse Order</h4> */}

            <div className="mainhd">
                <div className="d-flex justify-content-between align-items-center mainhdbrd">
                    <h4>New Purchase Order</h4>
                </div>
                <div className="formsec purchaseform">
                    <form onSubmit={handleSubmit}>
                        <div className="topformsec">
                            <div className="vendorsec">
                                <div className="row form-group">
                                    <div className="col-md-2">
                                        <label for="vendorName"><span className="required">Vendor Name*</span></label>
                                    </div>
                                    <div className="col-md-4 dropdown">
                                        <Select
                                            placeholder="Select"
                                            name="vendorName"
                                            options={vendorList}
                                            onChange={(selectedOption) => handleAddVendorNameChange(selectedOption)}

                                        />
                                        {errors.vendorName && <small className="text-danger">{errors.vendorName}</small>}
                                    </div>

                                </div>
                            </div>
                            <div className="row form-group mt-4">
                                <div className="col-md-2">
                                    <label for="deliveryAddress"><span className="required">Delivery Address*</span></label>
                                </div>
                                <div className="col-md-4 dropdown">
                                    <Select
                                        placeholder="Select"
                                        name="deliveryAddress"
                                        options={wareHouseList}
                                        onChange={(selectedOption) => handleWarehouseChange(selectedOption)}
                                    />
                                    {errors.deliveryAddress && <small className="text-danger">{errors.deliveryAddress}</small>}
                                </div>

                            </div>
                            <div className="row form-group mt-4">
                                <div className="col-md-2">
                                    <label for="productName"></label>
                                </div>
                                <div className="col-md-4">
                                    <div className="address">
                                        {isWarehouseSelected
                                            ? formData?.deliveryAddress
                                            : "Please select a warehouse to see the delivery address."}
                                    </div>

                                </div>
                            </div>

                            <div className="row form-group mt-4">
                                <div className="col-md-2">
                                    <label for="productName"><span className="required">Purchase Order#*</span></label>
                                </div>
                                <div className="col-md-4">
                                    <input
                                        type="text"
                                        className="form-control"
                                        onChange={handleChange}
                                        name="purchaseOrder"
                                        value={formData.purchaseOrder}
                                    />
                                    {errors.purchaseOrder && <small className="text-danger">{errors.purchaseOrder}</small>}
                                </div>
                            </div>

                            <div className="row form-group mt-4">
                                <div className="col-md-2">
                                    <label for="productName">Reference#</label>
                                </div>
                                <div className="col-md-4">
                                    <input
                                        type="text"
                                        className="form-control"
                                        onChange={handleChange}
                                        name="reference"
                                        value={formData.reference}
                                    />
                                </div>
                            </div>

                            <div className="row form-group mt-4">
                                <div className="col-md-2">
                                    <label for="productName">Date</label>
                                </div>
                                <div className="col-md-4">
                                    <input
                                        type="date"
                                        className="form-control"
                                        onChange={handleChange}
                                        onFocus={(e) => e.target.showPicker && e.target.showPicker()} // For Chrome-based browsers
                                        // defaultValue={today}
                                        name="date"
                                        value={formData.date}
                                    />
                                </div>
                            </div>

                            <div className="row form-group mt-4">
                                <div className="col-md-2">
                                    <label for="productName">Delivery Date</label>
                                </div>
                                <div className="col-md-4">
                                    <input
                                        type="date"
                                        className="form-control dateselector"
                                        onChange={handleChange}
                                        onFocus={(e) => e.target.showPicker && e.target.showPicker()} // For Chrome-based browsers
                                        name="deliveryDate"
                                        value={formData.deliveryDate}
                                    />
                                </div>
                                <div className="col-md-2">
                                    <label className="pdl40" for="productName">Payment Terms</label>
                                </div>
                                <div className="col-md-4 dropdown">
                                    <Select
                                        placeholder="Select Payment Terms"
                                        name="paymentTerms"
                                        options={paymentTermsList}
                                        onChange={(selectedOption) => handleAddPaymentTermsChange(selectedOption)}
                                    // value={formData.paymentTerms}  // Ensure the selected option stays persistent
                                    // components={{ MenuList: AddBrandMenuList }}
                                    // required
                                    />
                                    {/* {errors.brand && (
                                    <div className="text-danger">{errors.brand}</div>
                                )} */}
                                </div>

                            </div>
                            <div className="row form-group mt-4">
                                <div className="col-md-2">

                                    <label for="productName">Shipment preference</label>
                                </div>

                                <div className="col-md-4">
                                    <input
                                        type="text"
                                        className="form-control"
                                        onChange={handleChange}
                                        name="shipmentPreference"
                                        value={formData.shipmentPreference}
                                    />
                                </div>
                            </div>

                        </div>
                        <div className="purchaseTableSec purchaseItemTable customrowChangeOrderDetilas mt-5">
                            <div className="tablehd">
                                <div>Item Table</div>
                            </div>
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th>Item Details</th>

                                        <th style={{ width: "200px", textAlign: "left" }} className="align-middle">Account</th>
                                        <th style={{ width: "100px", textAlign: "right" }} className="align-middle">Quantity</th>
                                        <th style={{ width: "100px", textAlign: "right" }} className="align-middle">Rate</th>
                                        <th style={{ width: "100px", textAlign: "right" }} className="align-middle">Amount</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {formData.orderDetails.map((row, index) => {
                                        return (
                                            <tr>
                                                <td className="typheadsec align-middle">
                                                    <Typeahead
                                                        filterBy={[]}
                                                        id="custom-filtering-example"
                                                        // labelKey={(option) => `${option?.productName} - ${option?.color} - ${option?.size} - ${option?.brand} - ${option?.productCategory} - ${option?.subCategory} -${option?.mrpWithCashDiscount} -${option?.distributorId}`}
                                                        labelKey={(option) =>
                                                            [
                                                                option?.productName,
                                                                option?.color,
                                                                option?.size,
                                                                option?.brand,
                                                                option?.productCategory,
                                                                option?.subCategory,
                                                                option?.mrpWithCashDiscount,
                                                                option?.distributorId,
                                                            ]
                                                                .filter(Boolean) // removes null, undefined, empty string
                                                                .join(' - ')
                                                        }
                                                        options={itemListData}
                                                        placeholder="Search by product name, brand or Category..."
                                                        onInputChange={handleSearchChange}
                                                        onChange={(selected) => {
                                                            if (selected && selected[0]) {
                                                                const selectedId = formData?.vendorId;
                                                                const distributorProductId = selected[0]?.id;
                                                                handleSelectedId(selectedId, index, distributorProductId)
                                                            }
                                                        }}
                                                        renderMenuItemChildren={(option) => {
                                                            const formattedPrice = option?.mrpWithCashDiscount
                                                                ? parseFloat(option?.mrpWithCashDiscount).toFixed(2)
                                                                : "0.00";
                                                            return (
                                                                <div className="typeaheadData">
                                                                    <div className="d-flex">
                                                                        <div><small className="prodcolor">{option?.productName ? option?.productName : ''}</small></div>
                                                                    </div>

                                                                    <div className="d-flex">
                                                                        <div><small className="cateColor">{option?.productCategory ? option?.productCategory : ''}</small></div>
                                                                        <div className="ms-auto"><small className="subcatcolor">{option?.subCategory ? option?.subCategory : ''}</small></div>
                                                                    </div>
                                                                    <div className="d-flex">
                                                                        <div><small className="brandcolor">{option?.brand ? option?.brand : ''}</small></div>
                                                                        <div><small className="amtcolor ms-3">{formattedPrice ? formattedPrice : ''}</small></div>
                                                                        {/*<div className="ms-3"><small className="distcolor">{option.distributorId ? option.distributorId : ''}</small></div> */}
                                                                        {/* <div className="ms-auto"><small className="distcolor">{option?.shopName ? option?.shopName : ''}</small></div> */}
                                                                    </div>
                                                                    <div className="d-flex">
                                                                        <div><small className="size">{option?.size ? option?.size : ''}</small></div>
                                                                        <div className="ms-auto"><small className="color">{option?.color ? option?.color : ''}</small></div>
                                                                    </div>
                                                                </div>
                                                            )
                                                        }}
                                                    />
                                                </td>
                                                <td style={{ width: "200px", textAlign: "left" }} className="align-middle">
                                                    <Select
                                                        placeholder="Select"
                                                        name="account"
                                                        options={account}
                                                        onChange={(selectedOption) => handleAccountChange(selectedOption, index)}
                                                        className="accountSelect"
                                                    />
                                                </td>
                                                <td style={{ width: "100px", textAlign: "right" }} className="align-middle">
                                                    <input
                                                        type="number"
                                                        className="form-control AddingRowCss"
                                                        name="quantity"
                                                        value={row?.quantity}
                                                        onChange={(event) =>
                                                            handleUpdateRowChange(
                                                                event,
                                                                index,
                                                                "orderDetails"
                                                            )
                                                        }
                                                        style={{ textAlign: "right" }}
                                                    />
                                                </td>
                                                <td style={{ width: "100px", textAlign: "right" }} className="align-middle">
                                                    <input
                                                        type="number"
                                                        className="form-control AddingRowCssReadonly"
                                                        name="rate"
                                                        value={formData.orderDetails[index].rate}
                                                        onChange={(e) => handleRateChange(e, index)}
                                                        style={{ textAlign: "right" }}
                                                    />
                                                    {errors?.rate && (
                                                        <div className="text-danger">{errors?.rate}</div>
                                                    )}
                                                </td>
                                                <td style={{ width: "100px", textAlign: "right" }} className="align-middle">
                                                    <input
                                                        type="number"
                                                        className="form-control AddingRowCssReadonly"
                                                        name="totalAmount"
                                                        // value={row?.totalAmount}
                                                        value={formData.orderDetails[index].totalAmount}
                                                        style={{ textAlign: "right" }}
                                                        readOnly
                                                    />
                                                    {errors?.totalAmount && (
                                                        <div className="text-danger">
                                                            {errors?.totalAmount}
                                                        </div>
                                                    )}
                                                </td>
                                                <td>
                                                    {totalRoiRows.length > 1 && (
                                                        <div
                                                            style={{ color: "red", fontSize: "20px", cursor: "pointer" }}
                                                            onClick={() => totalRoiDeleteRow(row?.id, index)}
                                                        >
                                                            <MdDelete />
                                                        </div>
                                                    )}
                                                </td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </table>
                            {errors.orderDetails && (
                                <div className="text-danger mb-2">{errors.orderDetails}</div>
                            )}
                        </div>
                        <div className="notesTotalsec mt-3">

                            <div className="row">


                                <div className="add-line-item col-sm-6 d-flex flex-column">
                                    <div className="">
                                        <button type="button" className="btn btn-primary addnewRow" onClick={totalRoiAddRow}>+ Add New Row</button>
                                    </div>
                                    <div className="notesSec mt-auto">
                                        <h6>Customer Notes</h6>
                                        <textarea
                                            rows={3}
                                            placeholder="Will be displayed on purchase order"
                                            onChange={handleChange}
                                            name="customerNotes"
                                            value={formData.customerNotes}>
                                        </textarea>
                                    </div>
                                </div>
                                <div className="col-sm-6">
                                    <div className="totalSec">
                                        <div className="row">
                                            <div className="col-sm-4">
                                                <b className="subTotal">Sub Total</b>
                                            </div>
                                            <div className="col-sm-8 textright">
                                                <b className="subTotal">₹{subTotal.toFixed(2)}</b>
                                            </div>
                                        </div>
                                        <div className="row mt-4">
                                            <div className="col-sm-4">
                                                GST(%)
                                            </div>
                                            <div className="col-sm-4">
                                                <input type="text" className="form-control" value={formData.gst} onChange={handleGstChange} />
                                            </div>
                                            <div className="col-sm-4 textright">₹{gstAmount.toFixed(2)}</div>

                                        </div>
                                        <div className="row mt-4">
                                            <div className="col-sm-4">
                                                Discount(%)
                                            </div>
                                            <div className="col-sm-4">
                                                <input type="text" className="form-control" value={formData.discount} onChange={handleDiscountChange} />
                                            </div>
                                            <div className="col-sm-4 textright">₹{discountAmount.toFixed(2)}</div>
                                        </div>

                                        <div className="row mt-4">
                                            <div className="col-sm-4">
                                                <input type="text" className="form-control adjustment" name="adjustment" value={formData.adjustment} onChange={handleChange} />

                                            </div>
                                            <div className="col-sm-4">
                                                <input type="text" className="form-control adjustment" value={formData.adjustmentInRupees} onChange={handleAdjustmentChange} />
                                            </div>
                                            <div className="col-sm-4 textright">
                                                ₹{Number(formData.adjustmentInRupees || 0).toFixed(2)}
                                            </div>

                                        </div>

                                        <div className="totalbtmSec mt-4">
                                            <div className="row">
                                                <div className="col-sm-4">
                                                    <b className="total">Total</b>
                                                </div>
                                                <div className="col-sm-8 textright">
                                                    <b className="total">₹{finalTotal.toFixed(2)}</b>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="termsattachmentSec mt-5">
                            <div className="row">
                                <div className="col-sm-6">
                                    <div className="notesSec">
                                        <h6>Terms & Conditions</h6>
                                        <textarea
                                            rows={5}
                                            onChange={handleChange}
                                            placeholder="Enter the terms and conditions of your business to be displayed in your transaction"
                                            name="termsAndConditions"
                                            value={formData.termsAndConditions}
                                        ></textarea>

                                    </div>
                                </div>
                                <div className="col-sm-6 brdrt">
                                    <h6>Attach File(s) to Purchase Order</h6>
                                    <div className="fileuploadcontainer">
                                        <div className="fileUploadsec">
                                            <FaUpload /> <span>Upload File</span>
                                            <input
                                                type="file"
                                                className="fileupload"
                                                multiple
                                                onChange={handleFileChange}
                                                name="file"
                                            // value={formData.file}
                                            />
                                        </div>
                                    </div>
                                    <p className="note">You can upload a maximum of 10 files, 10MB each</p>
                                </div>
                            </div>
                        </div>
                        <div className="btnfooter">
                            <button className="btn btn-primary mt-4 mb-4" type="submit">Save & Send</button>
                            <Link to={'/purchaseorder'}><button className="btn btn-secondary ms-3">Cancel</button></Link>
                        </div>
                    </form>
                </div>
            </div>
            <Modal
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                style={customStyles}
                contentLabel="Example Modal"

            >
                <div className="addAddressModal">
                    <div className="modalHeader">
                        <h4 className="modal-title">Add Address</h4>
                        <button className="modalCloseBtn" onClick={closeModal}>
                            <FaRegTimesCircle />
                        </button>
                    </div>

                    {isLoadingOn ? <Loader /> : ""}
                    <div className="modalUserPaymentStatus addressbody">
                        <div className="row form-group">
                            <div className="col-md-3 label">Attention</div>
                            <div className="col-md-7">
                                <input type="text" className="form-control" />
                            </div>
                        </div>

                        <div className="row form-group mt-3">
                            <div className="col-md-3 label">Street 1</div>
                            <div className="col-md-7">
                                <textarea rows={3} className="form-control" placeholder="Street 1"></textarea>
                            </div>
                        </div>

                        <div className="row form-group mt-3">
                            <div className="col-md-3 label">Street 2</div>
                            <div className="col-md-7">
                                <textarea rows={3} className="form-control" placeholder="Street 2"></textarea>
                            </div>
                        </div>

                        <div className="row form-group mt-3">
                            <div className="col-md-3 label">City</div>
                            <div className="col-md-7">
                                <input type="text" className="form-control" />
                            </div>
                        </div>

                        <div className="row form-group mt-3">
                            <div className="col-md-3 label">State/Province</div>
                            <div className="col-md-7">
                                <input type="text" className="form-control" />
                            </div>
                        </div>

                        <div className="row form-group mt-3">
                            <div className="col-md-3 label">ZIP/Postal Code</div>
                            <div className="col-md-7">
                                <input type="text" className="form-control" />
                            </div>
                        </div>

                        <div className="row form-group mt-3">
                            <div className="col-md-3 label">Country/Region</div>
                            <div className="col-md-7">
                                <select className="form-control">
                                    <option value="0">Select Country</option>
                                    <option value="1">India</option>

                                </select>
                            </div>
                        </div>

                        <div className="row form-group mt-3">
                            <div className="col-md-3 label">Phone</div>
                            <div className="col-md-7">
                                <input type="text" className="form-control" />
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button className="btn btn-primary mt-4 mb-4">Submit</button>
                        <button className="btn btn-secondary ms-3" onClick={closeModal}>Cancel</button>
                    </div>
                </div>
            </Modal>
        </div>
    );
}

export default New;
